import React, { useEffect, useState } from 'react';
import * as S from './loader.styles';
import VodafoneLogoAnimated from './vodafone-logo';
export const Loader = ({ timeout = 300, height, width, inverted }) => {
    const [showLoader, setShowLoader] = useState(false);
    const loaderTimeout = React.useRef();
    // Checks if a timeout is given, and only shows loader after that interval.
    // If timeout is not given, it renders loader immediately.
    useEffect(() => {
        if (!timeout) {
            setShowLoader(true);
            return;
        }
        loaderTimeout.current = window.setTimeout(() => {
            setShowLoader(true);
        }, timeout);
        return () => {
            window.clearTimeout(loaderTimeout.current);
        };
    }, [timeout]);
    if (!showLoader)
        return null;
    return (React.createElement(S.Loader, { "data-testid": "loader" },
        React.createElement(S.Spinner, { className: "spinner", "data-testid": "spinner", width: width, height: height },
            React.createElement(VodafoneLogoAnimated, { className: "logo", width: width, height: height, inverted: inverted }))));
};
//# sourceMappingURL=loader.js.map